import React from 'react';

const AuthorizedLink = (props) => {
  const { permissionCode, userPermissionCodes, onClick, children, ...other } = props;

  if (!permissionCode || !!(userPermissionCodes || []).find((_) => _.toLowerCase() === permissionCode)) {
    return (
      <a {...other} onClick={onClick}>
        {children}
      </a>
    );
  }

  return children;
};

export default AuthorizedLink;
